<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
@font-face {
  font-family: "myFont";
  src: url("./assets/pingfang.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
	font-family:'Montserrat-SNaNpxiBoldItalic';
	src:url("./assets/fonts/Montserrat-SemiBoldItalic.ttf");
}
@font-face {
	font-family:'Logosc';
	src:url("./assets/fonts/Logosc.ttf");
}
html,
body {
  margin: 0;
  padding: 0;
  font-family: myFont, sans-serif;
}
</style>
